import { MS_PER } from '@/services/types/Time'

export default defineNuxtPlugin(() => {
  const { loadUserInfo, refreshLegacyToken } = useUserStore()
  const { checkMemoryUsage } = useReportsStore()

  useIntervalFn(refreshLegacyToken, MS_PER.Minute * 2)
  useIntervalFn(loadUserInfo, MS_PER.Minute)
  useIntervalFn(checkMemoryUsage, MS_PER.Minute)
})
